module.exports = __webpack_public_path__ + "static/media/banner-payroll.be92b3ec.jpg";